<template>
  <div>
    <gameOver v-if="showOver" :gameData="postGameData" :showNextButton="showNextButton" :score="gameScore" :gameFlag="gameFlag" :forbid="timeToForbid"
    @restart="restartTrain" @close="closeGame" @next="nextGame"></gameOver>
    <trainCronSave v-if="saveGame"
      :rest.sync="rest"
      :gameData="gameData"
      :gameFlag="gameFlag"
      :caseId="caseId"
      :todayGames="imgList"
      @restart="restartLanTrain"
      @updateScore="getGameScore"
      @close="saveGame=false">
    </trainCronSave>
    <div class="demo-grid">
      <mu-row gutter>
        <mu-col width="100" tablet="100" desktop="100">
          <span class="train-title">现场训练</span>
        </mu-col>
      </mu-row>
      <mu-row gutter>
        <mu-col width="100" tablet="100" desktop="100">
          <div v-if="showContent" class="game-style" v-for="item in imgList">
            <div class="pointer spanimg" @click="openGame(item)">
              <img :src="address+item.image" width="200px" height="200px"/>
              <span class="game-has-done" v-if="item.counts>0">已完成</span>
            </div>
            <div style="text-align:left;">{{item.name}}</div>
            <div style="display:flex;">
              <span style="font-size:10px;color:#999;margin-right:5px;">难度</span>
              <level :level="item.level"></level>
            </div>
          </div>
          <!-- <div class="add-style" @click="showAddModal=true"> -->
          <div class="add-style" @click="addModal">
          </div>
        </mu-col>
      </mu-row>
      <mu-row gutter>
        <mu-col width="100" tablet="100" desktop="100">
          <mu-raised-button class="train-btn" style="margin-right:20px;width:130px;background-color:#999;color:#fff;" label="返回档案列表" @click="confirmTrain(1)" />
          <mu-raised-button class="train-btn" label="结束训练" @click="confirmTrain(2)" primary />
        </mu-col>
      </mu-row>
      <div class="timer-show">
        <Ticker ref="Ticker" v-if="showTicker" :caseId="caseId" :time="timeLeft" :tmID="tmID" @timeOver="timeOver" @showClick="showClick"></Ticker>
      </div>
    </div>
    <div class="conf-dialog">
      <mu-dialog dialogClass="diaClass" bodyClass="bodyClass" titleClass="title" :open="showConf" title="训练设置">
        <selectLevel :defaultTime="defaultTime" :showHardBar="showHardBar"></selectLevel>
        <mu-raised-button  :disabled="!startTrain" style="position:absolute;right:100px;border-radius:30px;width:120px;height:40px;" slot="actions" @click="toTrain" primary label="开始训练"/>
        <mu-raised-button style="position:absolute;left:100px;border-radius:30px;width:120px;height:40px;color:#fff;background-color:#999;"  slot="actions" primary @click="close" label="取消"/>
      </mu-dialog>
    </div>
    <mu-dialog :open="showOverTrain">
      <span v-if="overFlag == 1">训练尚未结束，确定要离开吗？确认离开将暂停倒计时。</span>
      <span v-else>确定结束训练吗？</span>
      <mu-flat-button slot="actions" @click="overTrain(0)" primary label="取消"/>
      <mu-flat-button v-if="overFlag == 1" slot="actions" primary @click="overTrain(overFlag)" label="离开"/>
      <mu-flat-button v-else slot="actions" primary @click="overTrain(overFlag)" label="结束"/>
    </mu-dialog>
    <addMoreModal v-if="showAddModal" :games="imgList" @closeModal="cancelModal" @submitData="addTrain"></addMoreModal>
  </div>
</template>
<script>
  import Vue from 'vue'
  import {removeByValue,getPara} from '../../../assets/js/common.js'
  import Ticker from '../../common/timer/Ticker.vue'
  import level from '../../common/levels.vue'
  import trainCronSave from '../../common/trainCronSave.vue'
  import gameOver from '../../common/gameOver.vue'
  import addMoreModal from '../../service/case/trainPlan/addMoreModal.vue'
  import selectLevel from '../../common/selectLevel'
  import {mapState,mapMutations} from 'vuex'

  export default ({
    data() {
      return {
        saveGame: false,
        showOver: false,
        showTicker: false,
        showClickFlag: true, // 游戏是否可以点击
        gameFlag: 1, // 游戏标识，1为认知，2为言语
        gameData: {},
        gameScore: {},
        imgList: [],
        allTrainLists: [],
        time: '',
        caseId: this.$route.query.caseId,//getPara("caseId"),
        selectTrain: this.$route.query.selectTrain,//JSON.parse(decodeURIComponent(getPara("selectTrain"))),
        checkedID: [],
        getImgUrl: '',
        address: GLOBAL.cognition,
        showContent: true, // for renew train times
        showAddModal: false,
        showOverTrain: false,
        timeToForbid: false,
        overFlag: 0,
        tmID: '', // 训练id，gamesTM、finishTM、pauseTM、playTM都需要
        //训练设置
        showConf:false,
        rest:0,//再练一次时记录训练等级的flag
        showNextButton:true,//是否在训练小结页展示下一个训练按钮
        postGameData:"",//传给训练小结页面游戏信息用来完成下一次训练的功能
        defaultTime:2,
        showHardBar:true,
      }
    },
    computed: {
      timeLeft: function(){
        if(this.time == ''){
          return this.$route.query.time;
        } else {
          return this.time;
        }
      },
      ...mapState(["startTrain"])
    },
    components:{
      Ticker,
      level,
      addMoreModal,
      trainCronSave,
      gameOver,
      selectLevel
    },
    mounted: function(){
      this.getAllGames()
    },
    methods: {
      nextGame(res){
        //小结页点击下一个训练的逻辑
        var item;
        //获取下一个游戏的相关数据
        for(var i = 0; i < this.imgList.length; i++){
          if(res == this.imgList[i].id && this.imgList[i]){
            item = this.imgList[i+1]
          }
        }
        this.openGame(item);
      },
      close(){
        //关闭训练设置浮层
        this.showConf = false;
      },
      getAllGames(){//初始化获取所有游戏信息
        var obj = {}; //用来供reduce使用的对象
        Vue.http({
          method: 'GET',
          url: '/api/Game/getAllGames'
        })
        .then((res) => {
          this.allTrainLists = res.data.data.cogn.concat(res.data.data.lan).concat(res.data.data.men).concat(res.data.data.rehab_lan);
          this.allTrainLists = this.allTrainLists.reduce((cur,next) => {
              obj[next.name] ? "" : obj[next.name] = true && cur.push(next);
              return cur;
          },[]);
          // 进入该页面时，如果游戏是暂停状态，则触发开始
          Vue.http({
            method: 'GET',
            url: '/api/Train/infoTM',
            params: {
              patient_uuid: this.caseId
            }
          })
          .then((res)=>{
            this.selectTrain = res.data.data.checked
            this.tmID = res.data.data.id;
            this.time = res.data.data.time_left;
            this.$http.post('/api/Train/playTM',{
              'patient_uuid': this.caseId,
              'tm_id': this.tmID
            },{emulateJSON: false})
            .then((res)=>{
              this.time = res.data.left;
            })
            this.getTrain();
          })
        })
      },
      getTrain(item){
        this.showTicker = true;
        if(item){
          // 去除列表中的重复游戏
          var tempList = this.imgList;
          if(!this.imgList){
            tempList = []
            this.imgList = []
          }
          for(let i=0; i<Object.keys(item).length; i++){
            var addFlag = true;
            for(let j=0; j<tempList.length; j++){
              if(item[i].id == tempList[j].id){
                addFlag = false;
                break;
              }
            }
            if(addFlag){
              this.imgList.push(item[i])
              this.checkedID.push(item[i].id)
            }
          }
          // 把临时加的游戏上传到后台
          this.startTrains(item);
        } else {
          console.log(this.selectTrain)
          //从所有游戏中过滤正在训练的游戏
          //selectTrain 是选中游戏的id
          //allTrainLists是所有游戏
          for(let item in this.selectTrain){
            for(let oneTrain in this.allTrainLists){
              if(this.allTrainLists[oneTrain].id == this.selectTrain[item].id){
                this.allTrainLists[oneTrain]['counts'] = this.selectTrain[item].counts;
                this.imgList.push(this.allTrainLists[oneTrain]);
                this.checkedID.push(this.allTrainLists[oneTrain].id)
              }
            }
          }
        }
        console.log(this.imgList);
      },
      // 把临时选中的游戏也添加到后台保存
      startTrains(){
        this.$http.post('/api/Train/gamesTM',{
          'tm_id': this.tmID,
          'patient_uuid': this.caseId,
          'checked': this.checkedID
        },{emulateJSON: false})
        .then((res)=>{
          console.log(res)
        })
      },
      addTrain(item){
        this.showAddModal = false;
        this.getTrain(item);
        this.$refs.Ticker.timerPlay();
      },
      cancelModal:function(){
        this.showAddModal = false;
        this.$refs.Ticker.timerPlay();
      },
      toTrain(){
        this.saveGame = true;
        this.showConf = false;
      },
      openGame: function(res){
        //认知游戏进入浮层，言语游戏直接开始
        var ids = [];
        this.postGameData = res.id;
        for(var item of this.imgList){
          ids.push(item.id);
        }
        if(ids.indexOf(res.id) !== ids.length-1){
          this.showNextButton = true;
        }else{
          this.showNextButton = false;
        }
        if(res.p_id){
          if(this.showClickFlag && res.lesson_type == "b"){
            this.$store.commit("getData",res);
            this.showConf = true;
            this.gameData = res;
            this.defaultTime = 2;
            this.showHardBar = true;
          }else if(this.showClickFlag && res.lesson_type == "l"){
            this.$store.commit("getData",res);
            this.showConf = true;
            this.gameData = res;
            this.defaultTime = 5;
            this.showHardBar = false;
          }
        }else{
          if(this.showClickFlag){
            this.gameData = res;
            this.saveGame = true;
          }
        }
      },
      getGameScore: function(res,name,score){
        this.gameFlag = 1;
        this.showOver = true;
        this.saveGame = false;
        this.gameScore = res;
        this.gameScore['name'] = name;
        this.gameScore['lastScore'] = score;
      },
      // 关闭游戏结束显示分数页
      closeGame: function(){
        this.showOver = false;
        this.showContent = false;
        Vue.http({
          method: 'GET',
          url: '/api/Train/infoTM',
          params: {
            patient_uuid: this.caseId
          }
        })
        .then((res)=>{
          let newList = res.data.data.checked;
          for(let i=0; i<this.imgList.length; i++){
            for(let j=0; j<newList.length; j++){
              if(this.imgList[i].id == newList[j].id){
                this.imgList[i].counts = newList[j].counts;
              }
            }
          }
          this.showContent = true;
        })
      },
      confirmTrain: function(val){
        this.showOverTrain = true;
        this.overFlag = val;
      },
      // 关闭当前页面
      overTrain: function(val){
        if(val == 1){
          this.$http.post('/api/Train/pauseTM',{
            patient_uuid: this.caseId,
            'tm_id': this.tmID
          },{emulateJSON: false})
          .then((res)=>{
            this.$router.push({path: '/doc/caseList'});
          })
        } else if(val == 2){
          this.$http.post('/api/Train/finishTM',{
            patient_uuid: this.caseId,
            'tm_id': this.tmID
          },{emulateJSON: false})
          .then((res)=>{
            this.$router.push({path: '/doc/caseList'});
          })
        } else {
          this.showOverTrain = false;
        }
      },
      restartLanTrain: function(item){
        console.log(item)
        this.gameFlag = 2;
        this.showOver = true;
        this.saveGame = false;
        this.gameScore = item;
      },
      // 再练习一次
      restartTrain: function(rest){
        this.showOver = false;
        this.saveGame = true;
        this.rest = rest;
      },
      // 倒计时结束
      timeOver: function(){
        this.timeToForbid = true;
      },
      // 暂停时，游戏不可以点击
      showClick: function(flag){
        console.log(flag);
        this.showClickFlag = flag;
      },
      addModal: function(){
        this.showAddModal = true ;
        this.$refs.Ticker.timerPause();
      }
    }
  })
</script>
<style scoped>
.demo-grid div[class*="col-"] {
  text-align: center;
  padding: 8px;
  margin-top: 20px;
  margin-bottom: 8px;
}
.train-title{
  font-weight: bold;
  font-size: 16px;
}
.train-btn{
  border-radius: 40px;
  height: 40px;
  font-size: 16px;
}
  .game-style{
    display:flex;
    float: left;
    flex-direction: column;
    width: 200px;
    height: 200px;
    margin: 40px 20px;
  }
  .add-style{
    display: flex;
    float: left;
    align-items: center;
    justify-content: center;
    width: 200px;
    height: 200px;
    border: 1px solid #f5f5f5;
    margin: 40px 20px;
    content: '+';
    font-size: 64px;
  }
  .add-style:after {
    content: '+';
    font-size: 64px;
    cursor: pointer;
  }
  .timer-show{
    width:200px;
    height:200px;
    position:fixed;
    bottom:60px;
    right:50px;
  }
  .spanimg{
    position: relative;
  }
  .game-has-done{
    position: absolute;
    bottom: 0;
    right:0;
    color: orange;
    background-color: #fff;
    display: inline-block;
    width: 100%;
    opacity: 0.8;
    margin-bottom: 5px;
    font-weight: bold;
  }
  .diaClass{
    width:500px !important;
    max-width: 500px !important;
    height: 350px !important;
    max-height: 350px !important;
  }
  .diaClass  .mu-dialog-actions{
    position: relative;
    margin-top: 20px!important;
  }
  .title{
    justify-content:center!important;
    border-bottom: 1px solid #EEEEEE;
    color: #333333;
    font-size: 16px;
    font-weight: bold;
  }
  .bodyClass{
    margin-top:50px;
  }
</style>



// WEBPACK FOOTER //
// trainTime.vue?36262eea